const CONSUMER_ORGANIZATION_ID = 'UpM28mnfW65vJkbqEATtKvxm'

const configuration = {
  CONSUMER_ORGANIZATION_ID,

  BASE_URLS: {
    local: 'http://localhost:8888',
    productionOauth: 'http://52.41.133.15:8000/tigertextapi',
  },

  ADMIN_URLS: {},
  CN_URLS: {},
  FORGOT_PASSWORD_URLS: {},
  ROLES_URLS: {},

  CLOUDFRONT: {
    development: {
      d1n6bomzxlt9xn: 'tigertext/production/avatar',
      d18oyzjkq5093g: 'tigertext/production/avatar-group',
    },
    production: {
      d1n6bomzxlt9xn: 'tigertext/production/avatar',
      d18oyzjkq5093g: 'tigertext/production/avatar-group',
    },
    tt: {
      d1n6bomzxlt9xn: 'tigertext/production/avatar',
      d18oyzjkq5093g: 'tigertext/production/avatar-group',
    },
    ihis: {
      avatar: '',
      groupAvatar: '',
    },
  },

  CONFIG_DEFAULT: {
    apiEnv: 'production',
    assetDomain: 'assets.tigerconnect.com',
    autoAckSuccessfullyHandledEvents: true,
    autoSignOutOnBrowserUnload: true,
    baseUrl: null, // defaults to what is in apiEnv but can be overridden
    botUsers: [],
    clearTypingStatusThrottleDelay: 2000,
    clearTypingStatusTimeout: 8000,
    cloudfrontDomain: 'cloudfront.net',
    cloudfront: {},
    condensedReplays: false,
    consumerOrganizationId: CONSUMER_ORGANIZATION_ID,
    detectBangReplayTimeout: 1000,
    events: {
      autoAck: false,
      autoDeliver: false,
      canConfirm: true,
      closeAfterMessages: false,
      heartbeat: true,
      hidden: false,
      includeDistributionListEvents: true,
      isTyping: true,
      keepAlive: false,
      msgDeliveryDelay: 0,
      multiOrg: true,
      noOfflineMessages: false,
      renderMetadata: true,
    },
    eventCollectionInterval: 50,
    eventsAutoReconnect: true,
    eventsAutoReconnectDelay: 2000,
    eventsAutoReconnectMaxDelay: 16000,
    eventsClearRetryHistoryInterval: 60000,
    eventsDebugging: false,
    eventsHeartbeatIntervalVisible: 12000,
    eventsHeartbeatIntervalInvisible: 30000,
    eventsOpenTimeout: 6000,
    flushAckInterval: 1000,
    flushAckMaxConnections: 2,
    flushAckMaxEvents: 50,
    flushFindRecipientStatusInterval: 150,
    flushFindRecipientStatusMaxCount: 20,
    flushSetMessageStatusInterval: 1000,
    flushSetMessageStatusMaxCount: 500,
    keepConversationsForAllForums: false,
    localAdminUrl: null,
    localCnUrl: null,
    localRolesUrl: null,
    logLevel: 'error',
    manuallyRequestEventQueueBatch: false,
    maxEventBatch: 50,
    maxMetadataKeyCount: 8,
    organizationRostersChangeThrottleDelay: 500,
    placeholderEntityAllowLoading: true,
    placeholderEntityDelayBeforeRefreshing: 100,
    processingEvents: false,
    productKey: 'bc1oOf3DZXbnaNZ2LCWZGvSg',
    pushAgent: 'consumer',
    reportingV2Enabled: true,
    serviceLogLevels: {},
    signUpHashKey: '21d2ff3ffbf',
    signUpHashSalt: '%(xx*&x$&*%&',
    ttRoute: null,
    version: '1.0',
    wantCondensedReplays: true,
  },
}

// Dynamically add to the config file

!['stag', 'uat'].forEach(env => {
  configuration.BASE_URLS[env] = `https://${env}-devapi.tigertext.me`
  configuration.FORGOT_PASSWORD_URLS[env] = `https://${env}-forget.tigertext.com`
  configuration.CN_URLS[env] = `https://${env}-console.tigertext.me`
  configuration.ADMIN_URLS[env] = `https://${env}-console.tigertext.me/app/admin`
  configuration.ROLES_URLS[env] = `/${env}/app/roles/index.html`
})

// Aliases for production

!['ihis', 'prod', 'production', 'tt'].forEach(env => {
  configuration.BASE_URLS[env] = 'https://api.tigertext.me'
  configuration.FORGOT_PASSWORD_URLS[env] = 'https://forget.tigertext.com'
  configuration.CN_URLS[env] = 'https://home.tigertext.com'
  configuration.ADMIN_URLS[env] = 'https://home.tigertext.com/app/admin'
  configuration.ROLES_URLS[env] = '/app/roles/index.html'
})

!['ihis'].forEach(env => {
  configuration.CN_URLS[env] = `https://${env}.tigertext.com`
  configuration.ADMIN_URLS[env] = `https://${env}.tigertext.com/app/admin`
})

export default configuration
